<template>
    <div class="page-body">
      <div class="container-fluid">
        <Loader :loading="isLoading" />
        <loader-component v-if="isLoading" :loading="isLoading" />
        <div class="edit-profile">
          <div class="row">
            <div class="col-12 col-xl-12">
              <div class="card">
                <div class="card-header">
                  <div class="text-neutral-500 text-xl font-medium font-['Poppins'] leading-normal">
                    {{ companyId && companyId !== '' ? "Editar Compañia" : "Crear Compañia" }}
                  </div>
                </div>

              <!-- Tabs Navigation -->
              <div class="card-tabs">
                <div class="flex border-b">
                  <button 
                    @click="activeTab = 'general'" 
                    :class="{'border-b-2 border-blue-500 text-blue-500': activeTab === 'general'}"
                    class="px-4 py-2 text-neutral-500 font-medium"
                  >
                    General
                  </button>
                  <button 
                    @click="activeTab = 'ubicacion'" 
                    :class="{'border-b-2 border-blue-500 text-blue-500': activeTab === 'ubicacion', 'opacity-50 cursor-not-allowed': !isSocialTabEnabled}"
                    class="px-4 py-2 text-neutral-500 font-medium"
                    :disabled="!isSocialTabEnabled"
                  >
                    Ubicación
                  </button>
                  <button 
                    @click="activeTab = 'social'" 
                    :class="{'border-b-2 border-blue-500 text-blue-500': activeTab === 'social', 'opacity-50 cursor-not-allowed': !isSocialTabEnabled}"
                    class="px-4 py-2 text-neutral-500 font-medium"
                    :disabled="!isSocialTabEnabled"
                  >
                    Redes Sociales
                  </button>
                </div>
              </div>

                <div class="card-body" style="margin-top: 20px;">
                  <div v-if="activeTab === 'general'">
                    <form @submit.prevent="submitForm">
                      <div>
                        <div class="flex gap-8">
                          <!-- Cuadro para mostrar el logo o placeholder -->
                          <div class="w-[342px] h-[342px] bg-neutral-200 rounded-md border border-[#dee2e6] flex justify-center items-center relative overflow-hidden">
                            <!-- Texto inicial, solo visible si no hay imagen -->
                            <span v-if="!form.img_src" class="text-neutral-500 text-sm font-medium font-['Poppins'] absolute">
                              342 x 342
                            </span>
                            <!-- Vista previa de la imagen cargada -->
                            <img v-else :src="form.img_src" class="w-full h-full object-cover" alt="Vista previa de la imagen" />
                            <!-- Input para cargar imagen -->
                            <input 
                              ref="imageInput"
                              :key="imageInputKey"  
                              id="imageInput"
                              type="file" 
                              accept="image/*" 
                              class="absolute inset-0 opacity-0 cursor-pointer" 
                              @change="loadImage"
                            />
                            <!-- Botón para quitar la imagen -->
                            <button 
                              v-if="form.img_src"
                              @click.stop="removeImage"
                              class="absolute top-2 right-2 bg-white text-red-500 rounded-full w-6 h-6 flex items-center justify-center shadow-md hover:bg-red-500 hover:text-white transition duration-300 z-20"
                              title="Quitar imagen"
                            >
                              &times; <!-- Símbolo de X -->
                            </button>
                          </div>
                          <!-- ID y Nombre -->
                          <div class="flex flex-col gap-4">
                            <div class="w-[300px] h-[72px] flex-col justify-start items-start gap-1.5 inline-flex">
                              <label class="text-neutral-500 text-sm font-medium font-['Poppins'] leading-normal">Nombre</label>
                              <input 
                                  type="text" 
                                  v-model="form.name"
                                  class="self-stretch px-4 py-[9px] bg-white rounded-md border border-[#dee2e6] text-neutral-500 text-sm font-light font-['Poppins'] leading-normal"
                                  placeholder="Nombre de la compañia" 
                                  required 
                              />
                            </div>
                            <div class="w-[300px] h-[72px] flex-col justify-start items-start gap-1.5 inline-flex">
                                <label class="text-neutral-500 text-sm font-medium font-['Poppins'] leading-normal">Email</label>
                                <input 
                                    type="email" 
                                    v-model="form.email"
                                    class="self-stretch px-4 py-[9px] bg-white rounded-md border border-[#dee2e6] text-neutral-500 text-sm font-light font-['Poppins'] leading-normal"
                                    placeholder="Ingresa el email" 
                                    pattern="[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,}$"
                                    required 
                                />
                            </div>
                        </div>
                        <div class="flex flex-col gap-4">
                          <div class="w-[300px] h-[72px] flex-col justify-start items-start gap-1.5 inline-flex">
                              <label class="text-neutral-500 text-sm font-medium font-['Poppins'] leading-normal">Teléfono</label>
                              <input 
                                  type="tel" 
                                  v-model="form.phone"
                                  class="self-stretch px-4 py-[9px] bg-white rounded-md border border-[#dee2e6] text-neutral-500 text-sm font-light font-['Poppins'] leading-normal"
                                  placeholder="Teléfono de la compañia" 
                                  pattern="[\d\s\+\-\(\)]{10,}"
                                  title="Ingrese un número de teléfono válido (mínimo 10 dígitos)"
                                  required 
                              />
                          </div>
                          <div class="w-[300px] h-[72px] flex-col justify-start items-start gap-1.5 inline-flex">
                                <label class="text-neutral-500 text-sm font-medium font-['Poppins'] leading-normal">Sitio Web</label>
                                <input 
                                    type="url" 
                                    v-model="form.website"
                                    class="self-stretch px-4 py-[9px] bg-white rounded-md border border-[#dee2e6] text-neutral-500 text-sm font-light font-['Poppins'] leading-normal"
                                    placeholder="Ingresa el sitio web" 
                                    pattern="https?:\/\/(www\.)?[-a-zA-Z0-9@:%._\+~#=]{1,256}\.[a-zA-Z0-9()]{1,6}\b([-a-zA-Z0-9()@:%_\+.~#?&//=]*)"
                                    title="Ingrese una URL válida comenzando con http:// o https://"
                                />
                          </div>
                        </div>
                      </div>
                      <!-- Descripción -->
                        <div class="w-[716px] h-[168px] flex-col justify-start items-start gap-1.5 inline-flex">
                          <label class="text-neutral-500 text-sm font-medium font-['Poppins'] leading-normal">Descripción</label>
                          <ckeditor

                            v-model="form.description"
                     
                            :editor="editor"
                            :config="editorConfig"
                            class=" h-40"
                          ></ckeditor>
                        </div>
                      </div>
                      <!-- Botón -->
                      <div class="form-footer text-end mt-4">
                        <button type="submit" class="custom-create-btn">
                          <span class="custom-create-btn-text">Guardar</span>
                        </button>
                      </div>
                    </form>
                  </div>
                  <div v-if="activeTab === 'ubicacion'">
                    <FormLocationComponent
                      :property-id="companyId" 
                      :resp="data_company" 
                      Type="company" 
                    />
                  </div>
                  <div v-if="activeTab === 'social'">
                    <social-networks-form 
                      :company-id="companyId" 
                      @social-data-updated="handleSocialDataUpdate"
                    ></social-networks-form>
                  </div>
                </div>
                <!-- Mensaje de éxito -->
                <div v-if="successMessage" class="user-alert">
                  <div class="user-alert-content">
                    <div class="user-alert-text">
                      {{ successMessage }}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </template>
  
  <script>
  import axios from "axios";
  import { ref, computed, watch, onMounted } from "vue";
  import { useStore } from "vuex";
  import { useRouter } from "vue-router";
  import { useRoute } from "vue-router";
  import SocialNetworksForm from '@/components/company/NetworksCompanyComponent.vue'; // Import the new component
  import Loader from '@/components/loaderComponent.vue';
  import ClassicEditor from '@ckeditor/ckeditor5-build-classic';
  import FormLocationComponent from "../advisor/FormLocationComponent.vue";


  export default {
    components: {
      SocialNetworksForm,
      FormLocationComponent

    },
    setup() {
      let data_company = ref({});
      const isLoading = ref(true); // Inicializamos isLoading
      const activeTab = ref('general'); // Default active tab
      const store = useStore();
      const session = computed(() => store.getters.getUserSession);
      const route = useRoute();
      const companyId = computed(() => route.params.id);  // Obtener el ID del rol desde la URL
      const imageInputKey = ref(0); // Inicializa la clave
      const existingImageSrc = ref(null);
      const placeholderVisible = ref(true);
  
      const editor            = ref(ClassicEditor);
      const editorConfig = {
      toolbar: [
          "heading",
          "|",
          "bold",
          "italic",
          "underline",
          "strikethrough",
          "|",
          "link",
          "blockQuote",
          "|",
          "undo",
          "redo",
          "|",
          "numberedList",
          "bulletedList",
          "|",
          "alignment",
          "indent",
          "outdent",
          "|",

          "insertHR",
          "code",
          "codeBlock",
          "removeFormat",
      ],
      height: "500px",
      };

      const form = ref({
        id: "",
        name: "",
        description: "",
        email: "",       
        phone: "",     
        website: "",      
        slug: "",         
        img_src: null,        
      });
      const imageInput = ref(null);
      const successMessage = ref("");
      const router = useRouter();
  
      // Función para cargar los datos del rol cuando estamos en modo de edición
      const loadRoleData = async () => {
        if (companyId.value) {
          try {
            const token = session.value.token_api;
            if (!token) {
              console.error("No se ha encontrado el token de autenticación.");
              return;
            }
  
            const options = {
              headers: {
                Authorization: `Bearer ${token}`
              }
            };
  
            // Hacer la solicitud GET para obtener los datos del rol
            const response = await axios.get(`${process.env.VUE_APP_API_BASE_URL}/company-form/${companyId.value}`, options);
            console.log(response)
            if (response.status === 200) {
              // Asignar los datos al formulario
              data_company.value = response; 
              console.log("Datos recibidos en data_company:", data_company.value);
              form.value.id = response.data.resp.company.id;
              form.value.name = response.data.resp.company.name;
              form.value.description = response.data.resp.company.description || '';
              form.value.email = response.data.resp.company.email;
              form.value.phone = response.data.resp.company.phone;
              form.value.website = response.data.resp.company.website;
              form.value.img_src = response.data.resp.company.logo;
              existingImageSrc.value = response.data.resp.company.logo; // Asignar la imagen existente
              console.log(form.value.img_src);
              form.value.slug = response.data.resp.company.slug;
            }
          } catch (error) {
            console.error("Error al cargar los datos del rol:", error);
          } finally {
            isLoading.value = false;
          }
        }
      };
      const removeImage = () => {
        form.value.img_src = null; // Eliminamos la imagen
        placeholderVisible.value = true; // Mostramos el marcador de posición nuevamente

        // Restablecemos el valor del input para permitir cargar la misma imagen
        if (imageInput.value) {
          imageInput.value.value = null; // Restablece el input de archivo
        }

        // Cambia la clave para forzar la recreación del input
        imageInputKey.value += 1; // Incrementa la clave
      };
      const handleSocialDataUpdate = (socialData) => {
        // You can add logic here to handle social data if needed
        console.log('Social data updated:', socialData);
      };
      // Llamar a la función cuando el componente se monta
      onMounted(() => {
        loadRoleData();
      });
      const updateDescription = (event) => {
          form.value.description = event.target.value;
      };
      const isSocialTabEnabled = computed(() => {
        return companyId.value !== undefined && companyId.value !== null && companyId.value !== 0;
      });
      
      // Función para guardar o actualizar la compañía
      const submitForm = async () => {
        try {
          const token = session.value.token_api;
          if (!token) {
            console.error("No se ha encontrado el token de autenticación.");
            return;
          }

          const options = {
            headers: {
              Authorization: `Bearer ${token}`,
              "Content-Type": "application/json",
            },
          };

          const endpoint = companyId.value
            ? `${process.env.VUE_APP_API_BASE_URL}/company-update/${companyId.value}`
            : `${process.env.VUE_APP_API_BASE_URL}/company-update`;

          const method = companyId.value ? "post" : "post";

          // Aquí construimos el objeto dataToSend
          const dataToSend = { 
            ...form.value,
            // Solo incluir img_src si se ha modificado
            ...(form.value.img_src && form.value.img_src !== existingImageSrc.value ? { img_src: form.value.img_src } : {})
          };
          console.log(dataToSend)
          const response = await axios[method](endpoint, dataToSend, options);

          if (response.status === 200 || response.status === 201) {
            successMessage.value = companyId.value
              ? "Compañía actualizada con éxito."
              : "Compañía creada con éxito.";

            if (!companyId.value) {
              form.value = {
                name: "", email: "", phone: "", website: ""
              };
            }

            setTimeout(() => {
              successMessage.value = "";
              if (!companyId.value) {
                const newCompanyId = response.data.company_id;
                router.push({ 
                  name: 'company-form-edit',
                  params: { id: newCompanyId }
                });
              } else {
                router.push({ name: "company-list" });
              }
            }, 2000);
          }
        } catch (error) {
          console.error("Error al guardar la compañía:", error);
          if (error.response) {
            console.error("Error de servidor:", error.response.data);
            // Aquí puedes mostrar un mensaje de error más específico si lo deseas
            if (error.response.data.message) {
              successMessage.value = error.response.data.message; // Muestra el mensaje de error del servidor
            }
          }
        }
      };
      watch(activeTab, async (newTab) => {
        if (newTab === 'general' || newTab === 'social') {
          await loadRoleData();
        }
      });
      watch(
        () => route.params.id,
        (newId, oldId) => {
          // Verifica si el nuevo valor es diferente de null y si era null previamente
          if (newId !== oldId && newId !== null) {
            loadRoleData(); // Cargar los datos cuando cambie el ID de null a un valor
          }
        },
        { immediate: true } // Para ejecutar la primera vez también
      );

      // Método para cargar nueva imagen
      const loadImage = (event) => {
        const file = event.target.files[0];

        if (file) {
          const reader = new FileReader();
          reader.onload = (e) => {
            form.value.img_src = e.target.result; // Actualiza la imagen en base64
          };
          reader.readAsDataURL(file); // Convierte el archivo en una URL de datos
        }
      };
        
      return {
        Loader,
        form,
        submitForm,
        loadImage,
        data_company,
        updateDescription,
        activeTab,
        companyId,
        handleSocialDataUpdate,
        existingImageSrc,
        successMessage,
        editorConfig,
        removeImage,
        editor,
        isSocialTabEnabled
      };
    }
    
  };
  </script>
  